import BreadCrumb from 'components/BreadCrumb'
import Button from 'components/Button'
import Flex from 'components/Flex'
import LeftArrow from 'components/icons/LeftArrow'
import React from 'react'
import {
  ButtonFlex,
  JobRoleFlex,
  LeftSection,
  PlacementCursor,
  TopHeading,
  StudentCount,
  RightSideSection,
  DownloadButton,
} from '../style'

import { Spin } from 'antd'
import ResumeDownload from '../../../components/icons/DriveTableIcon/ResumeDownload'

const Header = ({
  breadCrumbData,
  handleShowStudent,
  currentSearchParams,
  BreadShowStudent,
  placementStudent,
  handleShowFolder,
  handleNavigateBack,
  tableloader,
  setIsNavigateEnabled,
  setBulkDownload,
  studentListId,
  isAllSelect,
  setActionDrawer,
  setStudentListId,
  setIsAllSelect,
  setStudentId
}) => {
  const getBreadCrumbData = breadCrumbData.filter(
    item => item.active === true && item.title !== 'Placement'
  )
  let studentLabel = placementStudent?.data?.count > 1 ? 'students' : 'student'

  const handleDownloadChange = async () => {
    const hasStudents = studentListId.length > 0;
    if (!hasStudents) return;
  
    if (studentListId.length <= 10 && !isAllSelect) {
      setActionDrawer(true);
    }else{
    setBulkDownload(true);
    }
  };
  

  return (
    <>
      <JobRoleFlex>
        <LeftSection centerVertically>
          {currentSearchParams.size !== 0 && (
            <PlacementCursor
              onClick={() => {
                handleNavigateBack()
              }}
              cursor={currentSearchParams.size !== 0}
            >
              <LeftArrow />
            </PlacementCursor>
          )}

          <Flex column>
            <BreadCrumb
              breadCrumbData={breadCrumbData}
              setIsNavigateEnabled={setIsNavigateEnabled}
              setStudentListId={setStudentListId}
              setIsAllSelect={setIsAllSelect}
              setStudentId={setStudentId}
            />
            <TopHeading>
              {getBreadCrumbData.length == 0
                ? 'Overview'
                : getBreadCrumbData[0].name === 'DIPLOMA Batches'
                ? 'Diploma Batches'
                : getBreadCrumbData[0].name.replace(/%20/g, ' ')}
            </TopHeading>
          </Flex>
        </LeftSection>

        <RightSideSection
          style={{ display: 'flex', alignItems: 'center', gap: '1em' }}
        >
          {currentSearchParams.size !== 0 &&
            (BreadShowStudent !== 'true' ? (
              <>
                {currentSearchParams.size === 11 && (
                  <DownloadButton
                  onClick={() => handleDownloadChange()}
                  style={{
                    opacity: studentListId?.length > 0 ? 1 : 0.5,
                    cursor: studentListId?.length > 0 ? 'pointer' : 'default',
                  }}
                >
                    <ResumeDownload />
                  </DownloadButton>
                )}

                <Button.Primary
                  text="Show Students"
                  onClick={handleShowStudent}
                />
              </>
            ) : (
              <>
                      <DownloadButton
                        onClick={() => handleDownloadChange()}
                        style={{
                          opacity: studentListId?.length > 0 ? 1 : 0.5,
                          cursor: studentListId?.length > 0 ? 'pointer' : 'default',
                        }}
                      >
                        <ResumeDownload />
                      </DownloadButton>
                 

                <ButtonFlex>
                  <Button.Primary
                    text="Show Folders"
                    onClick={handleShowFolder}
                  />
                </ButtonFlex>
              </>
            ))}
        </RightSideSection>
      </JobRoleFlex>
      <StudentCount>
        {currentSearchParams?.size !== 0 && (
          <b>
            {placementStudent !== '' && (
              <> {tableloader ? <Spin /> : placementStudent?.data?.count}</>
            )}{' '}
            {studentLabel}
          </b>
        )}
      </StudentCount>
    </>
  )
}
export default Header
